import React from "react";
import {
  SwitchBackground,
  SwitchIndicator,
  SwitchInput,
  SwitchLabel,
} from "@sonder/ui/source/styled/fragments/Switch";

interface SwitchProps {
  checked?: boolean;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
}

export const Switch = ({
  checked,
  className,
  onChange,
  title,
}: SwitchProps) => (
  <SwitchLabel className={className} title={title}>
    <SwitchInput checked={checked} type="checkbox" onChange={onChange} />
    <SwitchBackground />
    <SwitchIndicator />
  </SwitchLabel>
);
